export var OrderQuantityType;
(function (OrderQuantityType) {
    OrderQuantityType["A_LA_CARTE"] = "A_LA_CARTE";
    OrderQuantityType["BULK"] = "BULK_ORDER";
})(OrderQuantityType || (OrderQuantityType = {}));
export default OrderQuantityType;
